import { Controller } from "@hotwired/stimulus"

// Composer della chat: invio con Invio (a capo con Shift+Invio), textarea che
// cresce col testo, campo svuotato quando la richiesta è partita.
export default class extends Controller {
  static targets = ["input"]

  submitOnEnter(event) {
    if (event.key !== "Enter" || event.shiftKey) return
    event.preventDefault()
    if (this.inputTarget.value.trim()) this.element.requestSubmit()
  }

  autogrow() {
    this.inputTarget.style.height = "auto"
    this.inputTarget.style.height = `${this.inputTarget.scrollHeight}px`
  }

  clear() {
    this.inputTarget.value = ""
    this.inputTarget.style.height = "auto"
    this.inputTarget.focus()
  }
}
